module.exports = __webpack_public_path__ + "static/media/6.8cb014db.gif";